<template>
  <div>
    <h3>商品明細</h3>
    <button @click="test">class test</button>
    <div>
      <!-- デバック用データ切り替え -->
      商品明細切り替え
      <el-select
          v-model="switchData"
          @change="setData">
        <el-option v-for="option in [{value: 0, label: 'No1'}, {value: 1, label: 'No2(one)'}, {value: 2, label: 'No3(details)'}, {value: 3, label: 'No4(received)'}, {value: 4, label: 'No5(exchange)'}]"
            :key="option.value"
            :label="option.label"
            :value="option.value" />
      </el-select>
    </div>
    <!-- なるべく本番流用可能な作りにする -->
    <div class="button-group">
      <BaseButton :disabled="disableOrderEditButton"
          @click="changeMode('edit')">
        注文修正
      </BaseButton>
      <BaseButton :disabled="disableOrderItemExchangeButton"
          @click="changeMode('exchangeShipped')">
        交換出荷
      </BaseButton>
      <BaseButton :disabled="disableOrderReceivedButton"
          @click="changeMode('receive')">
        返品登録
      </BaseButton>
    </div>
    <div style="color: red;">
      モード：{{ mode }}
    </div>
    <BaseTableList
        :table-set-list="allQtyDetailList"
        :display-items="items">
      <template
          slot="operation"
          slot-scope="{ row }">
        <BaseOperationTooltip
            :list="getTooltipList(row.row)"
            placement="bottom-end" />
      </template>
    </BaseTableList>
    <el-dialog
        :visible.sync="qtyDialogVisible">
      <div style="width:200px;">
        {{ selectLabel }}
        <BaseValidSelect
            v-if="isDialogSelectDisplay"
            :options="dialogSelectOptions"
            :value="dialogSelectValue"
            popper-class="front-dialog"
            name="dialogSelect"
            size="mini"
            @input="onChange" />
      </div>
      <!-- modal table -->
      <table>
        <tr>
          <th v-for="(l, i) in headerList"
              :key="i"
              :style="{width:l.width+'px', minWidth:l.minWidth+'px'}"
              :class="l.headerClass">
            {{ typeof l.label==="function" ? l.label() : l.label }}
          </th>
        </tr>
        <tr v-for="(l, i) in detailList"
            :key="i">
          <td v-for="(p, ii) in l.properties"
              :key="ii"
              :colspan="p.colspan"
              :class="p.class">
            <BaseCell
                :editable="{anytime: true}"
                :properties="p"
                :display-item="selectItemData" />
          </td>
        </tr>
      </table>
      <BaseButton @click="qtyDialogClose">閉じる</BaseButton>
      <BaseButton @click="qtyDialogOk">OK</BaseButton>
    </el-dialog>
    出荷指図取消予定明細： {{ cancelExport }} <br>
    注文情報更新リクエスト： {{ request }}
    <div>
      <li>キャンセルは 未引当、処理待ち、指図待ち が 1以上</li>
      <li>キャンセル戻した場合は未引き当てに戻しますか？ → 今は処理待ちに戻すことにする。</li>
      <li>交換出荷新規行などの場合の数量計算が課題です。行単位で整合性が合わないです。数量計算に交換返品と交換出荷を入れるのがいいのではないかと思います。→出荷と返品の差分を計算に入れる。</li>
      <!-- <li>出荷指図取消と注文情報更新（処理待ち）の更新リクエストのところをちゃんとする</li> -->
      <li>交換出荷変更時の交換出荷指図の取消などは出荷指図取消APIがやるでいいんでしょうか？</li>
      <li>交換情報テーブルを新設し、キャンセル、消込は交換情報をもとに行う。出荷指図APIは交換元のUUIDと数量を配列で渡す。</li>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import x from '@/components/mixins/mixin'

// import * as config from '@/config';
// import common from '@/utils/common';

export default {
  name: 'Item',
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  filters: {
  },
  components: {
  },
  mixins: [x],
  data () {
    return {
      addModel: {
        sku: 1,
        position: null,
        qty: {
          数量: 0,
          初回注文数量: 0,
          未引当: 0,
          処理待ち: 0,
          指図待ち: 0,
          指図前キャンセル: 0,
          指図: 0,
          出荷完了: 0,
          出荷不可: 0,
          出荷前キャンセル: 0,
          振替: 0,
          未処理返品: 0,
          処理済返品: 0,
          未処理交換出荷_指図待ち: 0,
          未処理交換出荷_出荷待ち: 0,
          未処理交換出荷_実績: 0,
          処理済交換出荷: 0,
          未処理交換返品: 0,
          未処理返品_実績: 0,
          処理済交換返品: 0,
          未処理交換出荷不可: 0
        }
      },
      qtyDialogVisible: false,
      qtyDialogMode: null,
      dialogSelectOptions: [],
      dialogSelectValue: null,
      allQtyDetailList: [
        { label: '数量', path: 'qty.数量', type: 'Number' },
        { label: '初回注文数量', path: 'qty.初回注文数量', type: 'Number' },
        { label: '未引当', path: 'qty.未引当', type: 'Number' },
        { label: '処理待ち', path: 'qty.処理待ち', type: 'Number' },
        { label: '指図待ち', path: 'qty.指図待ち', type: 'Number' },
        { label: '指図前キャンセル', path: 'qty.指図前キャンセル', type: 'Number' },
        { label: '指図', path: 'qty.指図', type: 'Number' },
        { label: '出荷完了', path: 'qty.出荷完了', type: 'Number' },
        { label: '出荷不可', path: 'qty.出荷不可', type: 'Number' },
        { label: '出荷前キャンセル', path: 'qty.出荷前キャンセル', type: 'Number' },
        { label: '振替', path: 'qty.振替', type: 'Number' },
        { label: '未処理返品', path: 'qty.未処理返品', type: 'Number' },
        { label: '処理済返品', path: 'qty.処理済返品', type: 'Number' },
        { label: '未処理交換出荷_指図待ち', path: 'qty.未処理交換出荷_指図待ち', type: 'Number' },
        { label: '未処理交換出荷_出荷待ち', path: 'qty.未処理交換出荷_出荷待ち', type: 'Number' },
        { label: '未処理交換出荷_実績', path: 'qty.未処理交換出荷_実績', type: 'Number' },
        { label: '処理済交換出荷', path: 'qty.処理済交換出荷', type: 'Number' },
        { label: '未処理交換返品', path: 'qty.未処理交換返品', type: 'Number' },
        { label: '未処理返品_実績', path: 'qty.未処理返品_実績', type: 'Number' },
        { label: '処理済交換返品', path: 'qty.処理済交換返品', type: 'Number' },
        { label: '未処理交換出荷不可', path: 'qty.未処理交換出荷不可', type: 'Number' },
        { type: 'Slot', label: '', path: 'operation', width: '100px' }
      ],
      selectItemData: {},
      items: [
        {
          sku: 0,
          position: 0,
          qty: {
            数量: 0,
            初回注文数量: 0,
            未引当: 0,
            処理待ち: 0,
            指図待ち: 0,
            指図前キャンセル: 0,
            指図: 0,
            出荷完了: 0,
            出荷不可: 0,
            出荷前キャンセル: 0,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        }
      ],
      request: [],
      cancelExport: [],
      mode: null,
      switchData: null
    }
  },
  computed: {
    ...mapState({
    }),
    headerList () {
      const list = {
        cancel: [
          { label: '', width: 100 },
          { label: '未引当', width: 100 },
          { label: '処理待ち', width: 100 },
          { label: '指図待ち', width: 100 },
          { label: '出荷不可', width: 100 }
        ],
        itemChange: [
          { label: '', width: 100 },
          { label: '未引当', width: 100 },
          { label: '処理待ち', width: 100 },
          { label: '指図待ち', width: 100 }
        ],
        exportChange: [
          { label: '', width: 100 },
          { label: () => this.dialogSelectValue === 1 ? '処理待ち' : '指図待ち', width: 100 },
          { label: '指図予定', width: 100 }
        ],
        cancelCancellation: [
          { label: '', width: 100 },
          { label: '指図前キャンセル', width: 100 },
          { label: '出荷前キャンセル', width: 100 }
        ],
        exchangeShipped: [
          { label: '', width: 100 },
          { label: '交換出荷数', width: 100 }
        ],
        cancelExchangeShipped: [
          { label: '', width: 100 },
          { label: '未処理交換出荷_指図待ち', width: 100 },
          { label: '未処理交換出荷不可', width: 100 }
        ],
        received: [
          { label: '', width: 100 },
          { label: '未処理返品', width: 100 }
        ],
        cancelReceived: [
          { label: '', width: 100 },
          { label: '処理済返品', width: 100 }
        ]
      }
      return list[this.qtyDialogMode]
    },
    detailList () {
      const list = {
        cancel: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.未引当', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.処理待ち', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.指図待ち', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.出荷不可', class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: 'キャンセル', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_未引当', editableId: 'anytime', editableCondition: this.editableUnallocated, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_処理待ち', editableId: 'anytime', editableCondition: this.editable処理待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_指図待ち', editableId: 'anytime', editableCondition: this.editable指図待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_出荷不可', editableId: 'anytime', editableCondition: this.editableUnshipped, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '修正後', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.afterUnallocated, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after処理待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after指図待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.afterUnshipped, class: { right: true } }
            ]
          }
        ],
        itemChange: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.未引当', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.処理待ち', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.指図待ち', class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '商品振替', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_未引当', editableId: 'anytime', editableCondition: this.editableUnallocated, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_処理待ち', editableId: 'anytime', editableCondition: this.editable処理待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_指図待ち', editableId: 'anytime', editableCondition: this.editable指図待ち, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '修正後', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.afterUnallocated, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after処理待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after指図待ち, class: { right: true } }
            ]
          }
        ],
        exportChange: () => {
          return this.dialogSelectValue === 1
            ? [
              {
                properties: [
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.処理待ち', class: { right: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.指図待ち', class: { right: true } }
                ]
              },
              {
                properties: [
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '変更数', class: { bold: true, center: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_処理待ち', editableId: 'anytime', editableCondition: this.editable処理待ち, class: { right: true } },
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '-', class: { right: true } }
                ]
              },
              {
                properties: [
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '修正後', class: { bold: true, center: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after処理待ち, class: { right: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after指図予定, class: { right: true } }
                ]
              }
            ] : [
              {
                properties: [
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.指図待ち', class: { right: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.指図待ち', class: { right: true } }
                ]
              },
              {
                properties: [
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '変更数', class: { bold: true, center: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_指図待ち', editableId: 'anytime', editableCondition: this.editable指図待ち, class: { right: true } },
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '-', class: { right: true } }
                ]
              },
              {
                properties: [
                  { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '修正後', class: { bold: true, center: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after指図待ち, class: { right: true } },
                  { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after指図予定, class: { right: true } }
                ]
              }
            ]
        },
        cancelCancellation: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.指図前キャンセル', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.出荷前キャンセル', class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: 'キャンセル取消', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_指図前キャンセル', editableId: 'anytime', editableCondition: this.editable指図前キャンセル, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_出荷前キャンセル', editableId: 'anytime', editableCondition: this.editable出荷前キャンセル, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '反映後', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after指図前キャンセル, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after出荷前キャンセル, class: { right: true } }

            ]
          }
        ],
        exchangeShipped: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '交換出荷可能数', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.exchangeShippedAbleQty, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '交換出荷数', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_交換出荷', editableId: 'anytime', class: { right: true } }
            ]
          }
        ],
        cancelExchangeShipped: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.未処理交換出荷_指図待ち', class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.未処理交換出荷不可', class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '交換出荷取消', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_未処理交換出荷_指図待ち', editableId: 'anytime', editableCondition: this.editable未処理交換出荷_指図待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_未処理交換出荷不可', editableId: 'anytime', editableCondition: this.editable未処理交換出荷不可, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '反映後', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after未処理交換出荷_指図待ち, class: { right: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after未処理交換出荷不可, class: { right: true } }
            ]
          }
        ],
        received: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.未処理返品', class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '返品', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_未処理返品', editableId: 'anytime', editableCondition: this.editable未処理返品, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '反映後', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after未処理返品, class: { right: true } }
            ]
          }
        ],
        cancelReceived: [
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '現在', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty.処理済返品', class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: 'キャンセル取消', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'qty._$CCS_処理済返品', editableId: 'anytime', editableCondition: this.editable処理済返品, class: { right: true } }
            ]
          },
          {
            properties: [
              { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '反映後', class: { bold: true, center: true } },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION, path: this.after処理済返品, class: { right: true } }

            ]
          }
        ]
      }
      return this.qtyDialogMode === 'exportChange' ? list[this.qtyDialogMode]() : list[this.qtyDialogMode]
    },
    selectLabel () {
      const label = {
        itemChange: '振替先',
        exportChange: '変更モード'
      }
      return label[this.qtyDialogMode]
    },
    isDialogSelectDisplay () {
      return ['itemChange', 'exportChange', 'exchangeShipped'].includes(this.qtyDialogMode)
    },
    disableOrderEditButton () {
      const r = this.items.map(row => {
        return row.qty.未引当 < 1 && row.qty.処理待ち < 1 && row.qty.指図待ち < 1 && row.qty.指図前キャンセル < 1 && row.qty.出荷前キャンセル < 1
      })
      return r.includes(true)
    },
    disableOrderItemExchangeButton () {
      const r = this.items.map(row => {
        return (row.qty.出荷完了 - row.qty.未処理交換出荷不可 - row.qty.処理済返品 - row.qty.未処理交換返品 - row.qty.処理済交換返品 + row.qty.処理済交換出荷 < 1) && (row.qty.未処理交換出荷_指図待ち < 1 && row.qty.未処理交換出荷不可 < 1)
      })
      return r.includes(true)
    },
    disableOrderReceivedButton () {
      const r = this.items.map(row => {
        return row.qty.未処理返品 < 1 && row.qty.処理済返品 < 1
      })
      return r.includes(true)
    }
  },
  watch: {
  },
  created () {
  },
  beforeUpdate () {
  },
  mounted () {
  },
  methods: {
    setData (v) {
      const dataList = [[
        {
          sku: 1,
          position: 1,
          qty: {
            数量: 1,
            初回注文数量: 1,
            未引当: 1,
            処理待ち: 0,
            指図待ち: 0,
            指図前キャンセル: 0,
            指図: 0,
            出荷完了: 0,
            出荷不可: 0,
            出荷前キャンセル: 0,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        }
      ],
      [
        {
          sku: 2,
          position: 1,
          qty: {
            数量: 5,
            初回注文数量: 7,
            未引当: 0,
            処理待ち: 1,
            指図待ち: 1,
            指図前キャンセル: 1,
            指図: 1,
            出荷完了: 1,
            出荷不可: 1,
            出荷前キャンセル: 1,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        }
      ],
      [
        {
          sku: 3,
          position: 1,
          qty: {
            数量: 5,
            初回注文数量: 7,
            未引当: 0,
            処理待ち: 1,
            指図待ち: 1,
            指図前キャンセル: 1,
            指図: 1,
            出荷完了: 1,
            出荷不可: 1,
            出荷前キャンセル: 1,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        },
        {
          sku: 3,
          position: 2,
          qty: {
            数量: 2,
            初回注文数量: 2,
            未引当: 0,
            処理待ち: 1,
            指図待ち: 1,
            指図前キャンセル: 0,
            指図: 0,
            出荷完了: 0,
            出荷不可: 0,
            出荷前キャンセル: 0,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        }
      ],
      [
        {
          sku: 4,
          position: 1,
          qty: {
            数量: 1,
            初回注文数量: 2,
            未引当: 0,
            処理待ち: 0,
            指図待ち: 0,
            指図前キャンセル: 0,
            指図: 0,
            出荷完了: 0,
            出荷不可: 0,
            出荷前キャンセル: 0,
            振替: 0,
            未処理返品: 1,
            処理済返品: 1,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        }
      ],
      [
        {
          sku: 5,
          position: 1,
          qty: {
            数量: 1,
            初回注文数量: 1,
            未引当: 0,
            処理待ち: 0,
            指図待ち: 0,
            指図前キャンセル: 0,
            指図: 0,
            出荷完了: 1,
            出荷不可: 0,
            出荷前キャンセル: 0,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 0,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 0
          }
        },
        {
          sku: 5,
          position: 2,
          qty: {
            数量: 1,
            初回注文数量: 1,
            未引当: 0,
            処理待ち: 0,
            指図待ち: 0,
            指図前キャンセル: 0,
            指図: 0,
            出荷完了: 1,
            出荷不可: 0,
            出荷前キャンセル: 0,
            振替: 0,
            未処理返品: 0,
            処理済返品: 0,
            未処理交換出荷_指図待ち: 0,
            未処理交換出荷_出荷待ち: 0,
            未処理交換出荷_実績: 0,
            処理済交換出荷: 0,
            未処理交換返品: 1,
            未処理返品_実績: 0,
            処理済交換返品: 0,
            未処理交換出荷不可: 1
          }
        }
      ]
      ]
      this.items = dataList[v]
    },
    onChange (event) {
      if (this.qtyDialogMode === 'exportChange') {
        if ((this.dialogSelectValue === 1 && this.selectItemData.qty._$CCS_処理待ち !== 0) || (this.dialogSelectValue === 2 && this.selectItemData.qty._$CCS_指図待ち !== 0)) {
          alert('モード切り替えのため、入力値を 0 にします。')
          this._$CCS_未引当 = 0
          this._$CCS_処理待ち = 0
          this._$CCS_指図待ち = 0
          this._$CCS_出荷不可 = 0
        }
      }
      this.dialogSelectValue = event
    },
    getTooltipList (row) {
      switch (this.mode) {
        case 'edit':
          return [
            {
              title: 'キャンセル',
              disabled: () => this.disableCancelButton(row),
              click: (item) => this.toolTipButton(row, 'cancel')
            },
            {
              title: '商品振替',
              disabled: () => this.disableItemChangeButton(row),
              click: (item) => this.toolTipButton(row, 'itemChange')
            },
            {
              title: '指図数変更',
              disabled: () => this.disableExportChangeButton(row),
              click: (item) => this.toolTipButton(row, 'exportChange')
            },
            {
              title: 'キャンセル戻し',
              disabled: () => this.disableCancelCancellationButton(row),
              click: (item) => this.toolTipButton(row, 'cancelCancellation')
            }
          ]
        case 'exchangeShipped':
          return [
            {
              title: '交換出荷',
              disabled: () => this.disableExchangeShippedButton(row),
              click: (item) => this.toolTipButton(row, 'exchangeShipped')
            },
            {
              title: '交換出荷取消',
              disabled: () => this.disableCancelExchangeShippedButton(row),
              click: (item) => this.toolTipButton(row, 'cancelExchangeShipped')
            }
          ]
        case 'receive':
          return [
            {
              title: '返品登録',
              disabled: () => this.disableReceivedButton(row),
              click: (item) => this.toolTipButton(row, 'received')
            },
            {
              title: '返品取消',
              disabled: () => this.disableCancelReceivedButton(row),
              click: (item) => this.toolTipButton(row, 'cancelReceived')
            }
          ]
        default :
      }
    },
    disableItemChangeButton (row) {
      return row.qty.未引当 < 1 && row.qty.処理待ち < 1 && row.qty.指図待ち < 1
    },
    disableCancelButton (row) {
      return row.qty.未引当 < 1 && row.qty.処理待ち < 1 && row.qty.指図待ち < 1
    },
    disableExportChangeButton (row) {
      return row.qty.処理待ち < 1 && row.qty.指図待ち < 1
    },
    disableCancelCancellationButton (row) {
      return row.qty.指図前キャンセル < 1 && row.qty.出荷前キャンセル < 1
    },
    disableExchangeShippedButton (row) {
      return row.qty.出荷完了 - row.qty.未処理交換出荷不可 - row.qty.処理済返品 - row.qty.未処理交換返品 - row.qty.処理済交換返品 + row.qty.処理済交換出荷 < 1
    },
    disableCancelExchangeShippedButton (row) {
      return row.qty.未処理交換出荷_指図待ち < 1 && row.qty.未処理交換出荷不可 < 1
    },
    disableReceivedButton (row) {
      return row.qty.未処理返品 < 1
    },
    disableCancelReceivedButton (row) {
      return row.qty.処理済返品 < 1
    },
    toolTipButton (row, mode) {
      this.qtyDialogMode = mode
      this.qtyDialogVisible = true
      this.$set(row.qty, '_$CCS_未引当', 0)
      this.$set(row.qty, '_$CCS_処理待ち', 0)
      this.$set(row.qty, '_$CCS_指図待ち', 0)
      this.$set(row.qty, '_$CCS_出荷不可', 0)
      this.$set(row.qty, '_$CCS_指図前キャンセル', 0)
      this.$set(row.qty, '_$CCS_出荷前キャンセル', 0)
      this.$set(row.qty, '_$CCS_未処理返品', 0)
      this.$set(row.qty, '_$CCS_処理済返品', 0)
      this.$set(row.qty, '_$CCS_未処理交換出荷_指図待ち', 0)
      this.$set(row.qty, '_$CCS_未処理交換出荷不可', 0)
      this.$set(row.qty, '_$CCS_交換出荷', 0)

      this.selectItemData = row
      let list = null
      switch (mode) {
        case 'itemChange' :
          this.dialogSelectValue = 'new'
          list = (this.items.filter(item => {
            return (item.position !== row.position)
          })).map(v => ({ code: v.position, name: `明細NO：${v.position}` }))
          list.push({ code: 'new', name: '新規' })
          break
        case 'exportChange':
          this.dialogSelectValue = 1
          list = [{ code: 1, name: '指図予定を増やす' }, { code: 2, name: '指図予定を減らす' }]
          break
        case 'exchangeShipped':
          this.dialogSelectValue = row.position
          list = this.items.map(v => ({ code: v.position, name: `明細NO：${v.position}` }))
          list.push({ code: 'new', name: '新規' })
          break
        default:
          this.dialogSelectValue = null
      }
      this.dialogSelectOptions = list
    },
    /**
     * 編集可否
     */
    editableUnallocated (row) {
      return row.qty.未引当 > 0
    },
    editable処理待ち (row) {
      return row.qty.処理待ち > 0
    },
    editable指図待ち (row) {
      return row.qty.指図待ち > 0
    },
    editableUnshipped (row) {
      return row.qty.出荷不可 > 0
    },
    editable指図前キャンセル (row) {
      return row.qty.指図前キャンセル > 0
    },
    editable出荷前キャンセル (row) {
      return row.qty.出荷前キャンセル > 0
    },
    editable未処理交換出荷_指図待ち (row) {
      return row.qty.未処理交換出荷_指図待ち > 0
    },
    editable未処理交換出荷不可 (row) {
      return row.qty.未処理交換出荷不可 > 0
    },
    editable未処理返品 (row) {
      return row.qty.未処理返品 > 0
    },
    editable処理済返品 (row) {
      return row.qty.処理済返品 > 0
    },
    /**
     * 入力値反映結果
     */
    afterUnallocated (row) {
      return row.qty.未引当 - row.qty._$CCS_未引当
    },
    after処理待ち (row) {
      return row.qty.処理待ち - row.qty._$CCS_処理待ち
    },
    after指図待ち (row) {
      return row.qty.指図待ち - row.qty._$CCS_指図待ち
    },
    afterUnshipped (row) {
      return row.qty.出荷不可 - row.qty._$CCS_出荷不可
    },
    after指図予定 (row) {
      switch (this.dialogSelectValue) {
        case 1:
          return row.qty.指図待ち + row.qty._$CCS_処理待ち
        case 2:
          return row.qty.指図待ち - row.qty._$CCS_指図待ち
        default:
      }
    },
    after指図前キャンセル (row) {
      return row.qty.指図前キャンセル - row.qty._$CCS_指図前キャンセル
    },
    after出荷前キャンセル (row) {
      return row.qty.出荷前キャンセル - row.qty._$CCS_出荷前キャンセル
    },
    after未処理交換出荷_指図待ち (row) {
      return row.qty.未処理交換出荷_指図待ち - row.qty._$CCS_未処理交換出荷_指図待ち
    },
    after未処理交換出荷不可 (row) {
      return row.qty.未処理交換出荷不可 - row.qty._$CCS_未処理交換出荷不可
    },
    after未処理返品 (row) {
      return row.qty.未処理返品 - row.qty._$CCS_未処理返品
    },
    after処理済返品 (row) {
      return row.qty.処理済返品 - row.qty._$CCS_処理済返品
    },
    exchangeShippedAbleQty (row) {
      return row.qty.出荷完了 - row.qty.未処理交換出荷不可 - row.qty.処理済返品 - row.qty.未処理交換返品 - row.qty.処理済交換返品 + row.qty.処理済交換出荷
    },
    /**
     * event driven
     */
    changeMode (mode) {
      this.mode = mode
    },
    qtyDialogClose () {
      this.qtyDialogVisible = false
      this.qtyDialogMode = null
    },
    qtyDialogOk () {
      this.$loadingService.show()

      /**
       * 保存ボタン押下後にすること
       * 1. 現データを退避
       * 2. 出荷指図取消データ生成
       *    取消予定リストから現データの明細と指図待ち数を取得し、依頼用データを作成
       * 3. 変更前データと現データを比較して、増加している処理待ち数を取得 → 指図待ちと処理待ちを足した数で更新する方法でもいいんじゃない
       * 4. 出荷指図取消コール
       * 5. 出荷指図取消後のデータを取得
       * 6. 上記 3. で取得した数を 5. で取得したデータに加算した 注文情報更新用 リクエストを作成
       * 7. 注文情報更新をコール
       * 8. 注文情報更新後のデータを取得
       * 9. 2. で取得した数と 8. で取得した ID で出荷指図依頼をコール
       * 10. 8. で取得した ID を使用して 決済をコール
       */

      /**
       * 現在数量の更新
       */
      const setCalculateCurrentQty = (orderItem) => {
        const qty = orderItem.qty
        qty.数量 = qty.初回注文数量 - qty.指図前キャンセル - qty.出荷前キャンセル - qty.振替 - qty.処理済返品 + qty.未処理交換出荷_指図待ち + qty.未処理交換出荷_出荷待ち + qty.処理済交換出荷 - qty.未処理交換返品 - qty.処理済交換返品
        return orderItem
      }
      /**
       * 振替先の数量更新
       */
      const setCalculateItemChangeQty = (orderItem, targetOrderItem) => {
        const qty = orderItem.qty
        const processQty = qty._$CCS_未引当 + qty._$CCS_処理待ち + qty._$CCS_指図待ち
        orderItem.qty.振替 += processQty
        targetOrderItem.qty.振替 -= processQty
        targetOrderItem.qty.未引当 += processQty
        return targetOrderItem
      }

      // キャンセル
      const cancel = (orderItem) => {
        orderItem.qty.指図前キャンセル += orderItem.qty._$CCS_未引当 + orderItem.qty._$CCS_処理待ち + orderItem.qty._$CCS_指図待ち
        orderItem.qty.出荷前キャンセル += orderItem._$CCS_出荷不可
        return orderItem
      }

      // 基本パターン
      // 移動元から移動数を移動する（減算処理）
      // 移動先に計上する（加算処理）
      // 数量を再計算する
      const keys = ['未引当', '処理待ち', '指図待ち', '出荷不可', '指図前キャンセル', '出荷前キャンセル', '未処理返品', '処理済返品', '未処理交換出荷_指図待ち', '未処理交換出荷不可']
      for (const key of keys) {
        this.selectItemData.qty[key] -= this.selectItemData.qty[`_$CCS_${key}`]
      }

      // cancel
      if (this.qtyDialogMode === 'cancel') {
        cancel(this.selectItemData)
      // 振替
      } else if (this.qtyDialogMode === 'itemChange') {
        // 新規行
        if (this.dialogSelectValue === 'new') {
          let addModelClone = _.merge({}, this.addModel)
          addModelClone.position = _.maxBy(this.items, 'position').position + 1
          setCalculateItemChangeQty(this.selectItemData, addModelClone)
          setCalculateCurrentQty(addModelClone)
          this.items.push(addModelClone)
        // 既存行
        } else {
          let target = this.items.filter(item => item.position === this.dialogSelectValue)[0]
          setCalculateItemChangeQty(this.selectItemData, target)
          setCalculateCurrentQty(target)
        }
      // 指図変更
      } else if (this.qtyDialogMode === 'exportChange') {
        // 指図数を増やす
        if (this.dialogSelectValue === 1) {
          this.selectItemData.qty.指図待ち += this.selectItemData.qty._$CCS_処理待ち
        // 指図を減らす
        } else if (this.dialogSelectValue === 2) {
          this.selectItemData.qty.処理待ち += this.selectItemData.qty._$CCS_指図待ち
        }
      // キャンセル戻し
      } else if (this.qtyDialogMode === 'cancelCancellation') {
        this.selectItemData.qty.処理待ち += this.selectItemData.qty._$CCS_指図前キャンセル
        this.selectItemData.qty.出荷不可 += this.selectItemData.qty._$CCS_出荷前キャンセル
      // 交換出荷
      // TODO: 指図APIが更新する数量もある
      } else if (this.qtyDialogMode === 'exchangeShipped') {
        // 新規行
        if (this.dialogSelectValue === 'new') {
          let addModelClone = _.merge({}, this.addModel)
          addModelClone.position = _.maxBy(this.items, 'position').position + 1
          this.selectItemData.qty.未処理交換返品 += this.selectItemData.qty._$CCS_交換出荷
          addModelClone.qty.未処理交換出荷_指図待ち += this.selectItemData.qty._$CCS_交換出荷
          setCalculateCurrentQty(addModelClone)
          this.items.push(addModelClone)
        // 既存行
        } else {
          let target = this.items.filter(item => item.position === this.dialogSelectValue)[0]
          this.selectItemData.qty.未処理交換返品 += this.selectItemData.qty._$CCS_交換出荷
          target.qty.未処理交換出荷_指図待ち += this.selectItemData.qty._$CCS_交換出荷
          setCalculateCurrentQty(target)
        }
      // 交換出荷取消
      // TODO: 指図APIが更新する数量もある
      // キャンセルの方法は交換情報を選択する方式になるので、ひとまずこのままにしておく。
      } else if (this.qtyDialogMode === 'cancelExchangeShipped') {
        this.selectItemData.qty.未処理交換返品 -= this.selectItemData.qty._$CCS_未処理交換出荷_指図待ち + this.selectItemData.qty._$CCS_未処理交換出荷不可
      } else if (this.qtyDialogMode === 'received') {
        this.selectItemData.qty.処理済返品 += this.selectItemData.qty._$CCS_未処理返品
      } else if (this.qtyDialogMode === 'cancelReceived') {
        this.selectItemData.qty.未処理返品 += this.selectItemData.qty._$CCS_処理済返品
      }

      // 操作行の数量再計算
      setCalculateCurrentQty(this.selectItemData)

      // [指図待ち]の数が修正対象になっている場合
      // 処理待ち → 指図 にしたときにも処理待ちの更新が必要なので、指図数が変更になっている場合の条件にする
      if (this.selectItemData.qty._$CCS_指図待ち) {
        console.log('出荷指図を取り消すために出荷指図 UUID を取得します。')
        // getOrderExportsUuidByOrderItemId()
        // 取消対象の出荷指図 UUID を取得する。保存時に取得した UUID をチェックし、取消対象の明細を特定。
        // 取消対象の明細の[指図待ち]の数を出荷指図登録依頼の数として設定する。
        if (!this.cancelExport.find(obj => obj.position === this.selectItemData.position)) {
          this.cancelExport.push({ position: this.selectItemData.position })
        }
        // 処理待ちは出荷取消で処理待ちが更新された後に他の移動分を反映させる必要があるため、処理待ちと指図待ちの合計値で保持しておく
        if (!this.request.find(obj => obj.position === this.selectItemData.position)) {
          this.request.push({ position: this.selectItemData.position, 処理待ち: this.selectItemData.qty.処理待ち + this.selectItemData.qty.指図待ち })
        }
      }
      this.qtyDialogMode = null
      this.qtyDialogVisible = false
      this.$loadingService.close()
    },
    test () {
      const F = new TestClass(this.items[0])
      console.log(F)
    }
  }
}
class TestClass {
  constructor (item) {
    this.current = item.qty.数量
    this.ordered = item.qty.初回数量注文
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/item.vue